import { Alert, Button, FormControl, InputLabel, OutlinedInput, Stack } from "@mui/material";
import { FormEvent, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import useRequests from "../hooks/http";
import { Status } from "../enums/status";
import StatusDisplay from "../components/feedback/Status";

export default function ResetConfirm() {
  const { post } = useRequests();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState(Status.PENDING);
  const [message, setMessage] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      setMessage("Invalid or missing reset token. Please request a new reset link.");
      setStatus(Status.ERROR);
    }
  }, [token]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match.");
      setStatus(Status.ERROR);
      return;
    }

    setStatus(Status.LOADING);
    const { data, status: httpStatus } = await post("/password/reset", {
      token,
      new_password: newPassword,
    });

    if (httpStatus && httpStatus >= 200 && httpStatus < 300) {
      setMessage(data?.message || "Your password has been reset. You can now log in.");
      setStatus(Status.SUCCESS);
    } else {
      setMessage(data?.detail || "The reset link is invalid or has expired. Please request a new one.");
      setStatus(Status.ERROR);
    }
  };

  return (
    <Stack component={"form"} sx={{ flexGrow: 1 }} spacing={2} onSubmit={handleSubmit}>
      <Alert severity="info">Choose a new password for your account.</Alert>

      <StatusDisplay status={status} message={message} />

      <FormControl fullWidth={true}>
        <InputLabel htmlFor="new-password">New password</InputLabel>
        <OutlinedInput
          id="new-password"
          placeholder="New password"
          label="New password"
          type="password"
          name="new-password"
          autoComplete="new-password"
          required
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          disabled={!token || status === Status.SUCCESS}
        />
      </FormControl>

      <FormControl fullWidth={true}>
        <InputLabel htmlFor="confirm-password">Confirm new password</InputLabel>
        <OutlinedInput
          id="confirm-password"
          placeholder="Confirm new password"
          label="Confirm new password"
          type="password"
          name="confirm-password"
          autoComplete="new-password"
          required
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          disabled={!token || status === Status.SUCCESS}
        />
      </FormControl>

      <Button
        variant="contained"
        type="submit"
        disabled={!token || status === Status.LOADING || status === Status.SUCCESS}
      >
        Reset password
      </Button>
      <Button component={Link} to="/">
        Back to login
      </Button>
    </Stack>
  );
}
